module.exports = __webpack_public_path__ + "media/components/application/PaymentCard/icons/amex-f13e4bfda2cfa923909031b4c1c37302.svg";